var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Live = OCS.WxBriefing.Live || {};

/**
 * PanelManager Class
 *
 * This class manages the User Interface of the panel configurations
 * within the weather briefing page.
 *
 * @module UI
 * @submodule Managers
 * @class PanelManager
 * @constructor
 * @requires Moolite 1.0.1+ 
 *
 */

OCS.WxBriefing.Classes.PanelManager = new Class({
    Implements: [OCS.WxBriefing.Classes.SingletonManager],
    manager_name: 'PanelManager',
    debug: false,
    product_to_panel: {},
    num_of_panels: 0,
    current_panel: 1,
    is_url_image_regexp: new RegExp(/\.(jpeg|jpg|gif|png)$/),
    is_current_conditions_regexp: new RegExp(/wbp_current_conditions$/),
    is_started: false,
    history_manager_started: false,
    events: {},
    bound_methods: {},
    container: null,
    options: {
        panel_layout_config_location: "/config/panel_layout_config.json",
        panel_manager_id: 'panel_container',
        panel_id_name_prefix: 'panel_',
        panel_class_name: 'panel',
        update_url_event_string: 'update_url_event',
        default_panel_config: 'two_by_two',
        drag_handle: '.drag_handle'
    },
    init: function (op) {
        this.bound_methods.on_draggable_drop = this.on_draggable_drop.bind(this);
        this.bound_methods.on_url_state_change = this.on_url_state_change.bind(this);
        this.bound_methods.init_panel_config = this.init_panel_config.bind(this);
        this.setOptions(op);
        this.container = document.id(this.options.panel_manager_id);
        if (!this.container) {
            // Mostly here for testing purposes.
            this.container = new Element('div', {id: this.options.panel_manager_id});
        }

        // We need this style for al the panels f
        if (OCS.DynamicScriptLoader) {
            OCS.DynamicScriptLoader.load({'load': OCS.Package.root + 'css/ocsviewer-stylesheet.css', prepend: true});
        }
        this.init_panel_config();
//        var req;
//        var am = OCS.Functions.get_ajax_manager();
//        req = am.request("panel_layout_config", {
//            url: this.options.panel_layout_config_location,
//            dataType: "json",
//            corsRequest: false,
//            type: "GET",
//            onSuccess: function (data) {
//                OCS.Constants.PANEL_LAYOUTS = data.json;
//                this.init_panel_config();
//            }.bind(this)
//        });
//        req.send();

    },
    start: function () {
        this.is_started = true;
        this.init_history_manager();
    },
    init_history_manager: function () {
        if (!this.history_manager_started) {
            this.history_manager_started = true;
            var url_mngr = OCS.WxBriefing.Functions.get_url_manager();
            var current_state = url_mngr.current_url_state;
            if (!current_state.panel_config) { // force a default panel_config if not provided
                url_mngr.update_url_state({panel_config: this.options.default_panel_config}, 0);
            }
            url_mngr.addEvent(url_mngr.options.url_state_change_event, this.bound_methods.on_url_state_change);
        }
    },
    init_panel: function (panel_element) {
        var df = new OCS.WxBriefing.Classes.DragFunctionality(panel_element, {
            drag_handle: '.drag-handle',
            drag_start_timeout: 100,
            onDropped: this.bound_methods.on_draggable_drop
        });
    },
    init_panel_config: function () {
        var url_mngr = OCS.WxBriefing.Functions.get_url_manager();
        var current_state = url_mngr.current_url_state;
        var panel_config = this.get_panel_config(current_state.panel_config);
        this.container.removeProperty('class').addClass(panel_config.template);
        this.build_panel_config(panel_config, {panel_count: 0});
        this.init_panels('#' + this.options.panel_manager_id + ' div.' + this.options.panel_class_name);
    },
    init_panels: function (element_selector) {
        $$(element_selector).each(this.init_panel, this);
    },
    load_panel_config: function (state, old_state) {
        if (!old_state) {
            old_state = {};
        }
        var panel_config = this.get_panel_config(state.panel_config);

        // Test if we changing the panel config
        if (state !== null || panel_config.template !== old_state.panel_config) {
            // Set the panel container to the new panel config class
            this.container.removeProperty('class').addClass(panel_config.template);
            this.build_panel_config(panel_config, {panel_count: this.get_panel_count()});
            OCS.WxBriefing.Live.UI.send_analytic_event({'category': 'Preferences', 'action': "Panel Config", 'label': panel_config.template});
        }
    },
    build_panel_config: function (panel_config, options) {
        if (options.panel_count !== undefined && panel_config.num_of_panels !== options.panel_count) {
            var i = options.panel_count;
            if (panel_config.num_of_panels > options.panel_count) {
                i++;
                for (i; i <= panel_config.num_of_panels; i++) {
                    this.create_panel(i, options);
                }
            } else {
                for (i; i > panel_config.num_of_panels; i--) {
                    this.destroy_panel(i, options);
                }
            }
        }
    },
    create_panel: function (id, options) {
        var panel_ops = {'update_url_event_string': this.options.update_url_event_string};
        if (options.hasOwnProperty('type')) {
            panel_ops.panel_id = options.type + '_' + this.options.panel_id_name_prefix + id;
        } else {
            panel_ops.panel_id = this.options.panel_id_name_prefix + id;
        }
        if (options.hasOwnProperty('panel_container')) {
            panel_ops.panels_container = options.panel_container;
        } else {
            panel_ops.panels_container = this.container;
        }
        if (options.hasOwnProperty('append_to_container')) {
            panel_ops.append_to_container = options.append_to_container;
        }
        if (options.hasOwnProperty('popup')) {
            panel_ops.popup = options.popup;
        }
        if (options.hasOwnProperty('class_name')) {
            panel_ops.class_name = options.class_name;
            if (options.hasOwnProperty('type')) {
                panel_ops.class_name += " " + this.options.panel_id_name_prefix + id;
            }
        }
        return this.create_panel_obj(document.id(panel_ops.panel_id), panel_ops);
    },
    destroy_panel: function (id, options) {
        var panel_ops = {};
        if (options.hasOwnProperty('type')) {
            panel_ops.panel_id = options.type + '_' + this.options.panel_id_name_prefix + id;
        } else {
            panel_ops.panel_id = this.options.panel_id_name_prefix + id;
        }
        var panel_el = document.id(panel_ops.panel_id);
        if (panel_el) {
            var panel_obj = this.create_panel_obj(panel_el);
            panel_obj.destroy();
        }
    },
    get_panel_count: function () {
        if (this.container) {
            return this.container.getChildren().length;
        } else {
            return 0;
        }
    },
    get_panel_config: function (config_name) {
        // If we don't have a config or this is a mobile device get a default config
        if (!config_name) {
            config_name = this.options.default_panel_config;
        }
        var panel_config = OCS.Constants.PANEL_LAYOUTS[config_name];
        if (!panel_config && config_name === this.options.default_panel_config) {
            return;
        }
        if (!panel_config) {
            return this.get_panel_config();
        }
        return panel_config;
    },
    create_panel_obj: function (container, ops) {
        return new OCS.WxBriefing.Classes.PanelObj(container, ops);
    },
    /*
     * 
     * Event Handlers
     * 
     */
    on_draggable_drop: function (element, droppable, event, df) {
        if (droppable) {
            var state = {};
            var target_panel_id = droppable.getProperty('id').replace('drop_panel_', 'panel_')
            var source_panel_obj = element.retrieve('panel_obj');
            var target_panel_obj = document.id(target_panel_id).retrieve('panel_obj');
            if (target_panel_obj) {
                target_panel_obj.set_panel_id(source_panel_obj.get_panel_id());
            }
            source_panel_obj.set_panel_id(target_panel_id);
        }
    },
    on_url_state_change: function (new_state, old_state, url_manager) {
        if (!new_state.panel_config) { // force a default panel_config if not provided
            url_manager.update_url_state({panel_config: this.options.default_panel_config}, 0);
        }
        this.load_panel_config(new_state, old_state);
        if (OCS.device.desktop) {
            this.init_panels('#' + this.options.panel_manager_id + ' div.' + this.options.panel_class_name);
        }
    },

    destroy: function () {
        this.remove_registered_events();
        this.is_started = false;
        OCS.WxBriefing.Functions.get_url_manager().destroy();
        for (var i = 1; i <= this.get_panel_count(); ++i) {
            this.destroy_panel(i, {});
        }
        if (this.container) {
            this.container.empty();
            this.container = null;
        }
    }
}); // OCS.WxBriefing.Classes.PanelManager

